const Footer = () => {

    return (
        <div className="footer">

            <p>&copy; 2026 WeaveWords. All rights reserved.</p>

        </div>
    );
}
export default Footer;